import React from 'react';

const PostCodeManual = ({ register, validationMsg }) => {

  const fieldClass = "w-100 bg-transparent border-0 py-2 text-gray-800 fw-medium px-2";
  const fieldsetClass = "input-wrapper border rounded p-0 pb-1 px-3 position-relative w-100 transition-colors rounded-10";

  return (
    <div className="row">

      <div className="col-12 mb-4">
        <fieldset className={fieldsetClass}>
          <legend className="px-1 ms-2 fw-semibold tracking-wide fs-11">
            Address Line 1 <span className="text-red-500">*</span>
          </legend>
          <input
            type="text"
            placeholder="Address Line 1"
            name="txtHouseNumber"
            id="txtHouseNumber"
            className={fieldClass}
            style={{ outline: 'none' }}
            ref={register({ required: 'Please Enter Address Line 1' })}
            onChange={() => {}}
          />
          {validationMsg?.txtHouseNumber && (
            <p className="error_msg">{validationMsg.txtHouseNumber.message}</p>
          )}
        </fieldset>
      </div>

      <div className="col-12 mb-4">
        <fieldset className={fieldsetClass}>
          <legend className="px-1 ms-2 fw-semibold tracking-wide fs-11">
            County <span className="text-red-500">*</span>
          </legend>
          <input
            type="text"
            placeholder="County"
            name="txtCounty"
            id="txtCounty"
            className={fieldClass}
            style={{ outline: 'none' }}
            ref={register({ required: 'Please Enter County' })}
            onChange={() => {}}
          />
          {validationMsg?.txtCounty && (
            <p className="error_msg">{validationMsg.txtCounty.message}</p>
          )}
        </fieldset>
      </div>

      <div className="col-12 mb-4">
        <fieldset className={fieldsetClass}>
          <legend className="px-1 ms-2 fw-semibold tracking-wide fs-11">
            Town <span className="text-red-500">*</span>
          </legend>
          <input
            type="text"
            placeholder="Town"
            name="txtTown"
            id="txtTown"
            className={fieldClass}
            style={{ outline: 'none' }}
            ref={register({ required: 'Please Enter Town' })}
            onChange={() => {}}
          />
          {validationMsg?.txtTown && (
            <p className="error_msg">{validationMsg.txtTown.message}</p>
          )}
        </fieldset>
      </div>

      <div className="col-12 mb-4">
        <fieldset className={fieldsetClass}>
          <legend className="px-1 ms-2 fw-semibold tracking-wide fs-11">
            Country <span className="text-red-500">*</span>
          </legend>
          <input
            type="text"
            placeholder="Country"
            name="txtCountry"
            id="txtCountry"
            className={fieldClass}
            style={{ outline: 'none' }}
            ref={register({ required: 'Please Enter Country' })}
            onChange={() => {}}
          />
          {validationMsg?.txtCountry && (
            <p className="error_msg">{validationMsg.txtCountry.message}</p>
          )}
        </fieldset>
      </div>

      <div className="col-12 mb-4">
        <fieldset className={fieldsetClass}>
          <legend className="px-1 ms-2 fw-semibold tracking-wide fs-11">
            District <span className="text-red-500">*</span>
          </legend>
          <input
            type="text"
            placeholder="District"
            name="txtDistrict"
            id="txtDistrict"
            className={fieldClass}
            style={{ outline: 'none' }}
            ref={register({ required: 'Please Enter District' })}
            onChange={() => {}}
          />
          {validationMsg?.txtDistrict && (
            <p className="error_msg">{validationMsg.txtDistrict.message}</p>
          )}
        </fieldset>
      </div>

      {/* Hidden fields */}
      <input type="hidden" name="txtAddress2" id="txtAddress2" defaultValue="" ref={register()} />
      <input type="hidden" name="txtManual" id="txtManual" defaultValue="1" ref={register()} />

    </div>
  );
};

export default PostCodeManual;